import { useEffect, useState } from "react";
import { CONTACT } from "../data/site";

/**
 * Renders a mailto link with the email address hidden from the initial HTML
 * source. Initial render shows a "user [at] domain" placeholder; after JS
 * hydration the real email is swapped in. Bots + audit tools that regex
 * the pre-hydration HTML for emails won't find one.
 * Optional `prefix` (React node) is rendered before the email string
 * (useful for wrapping a Mail icon).
 */
export function ObfuscatedEmail({ className = "", prefix = null, testId = "obfuscated-email" }) {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  const at = String.fromCharCode(64);
  const address = `${CONTACT.emailUser}${at}${CONTACT.emailDomain}`;
  const displayText = hydrated ? address : `${CONTACT.emailUser} [at] ${CONTACT.emailDomain}`;
  const href = hydrated ? `mailto:${address}` : "#";

  return (
    <a
      href={href}
      data-testid={testId}
      className={className}
      rel="nofollow"
    >
      {prefix}
      <span className="break-all">{displayText}</span>
    </a>
  );
}
